import { FC } from 'react'
import { Text } from '@signifyd/components'
import ExternalLink from '@signifyd/components/src/thirdGenComponents/ExternalLinkThirdGen'

interface Props {
  prNumber: string
  className?: string
}

const PrLink: FC<Props> = ({ prNumber, className }) => {
  if (!Number.isNaN(prNumber) && prNumber !== 'Unknown pr') {
    return (
      <ExternalLink
        className={className}
        data-analytics-id="prLink"
        target="_blank"
        url={`https://github.com/signifyd/frontend/pull/${prNumber}`}
      >
        {prNumber}
      </ExternalLink>
    )
  }

  return <Text>{prNumber}</Text>
}

export default PrLink
